var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.notifyPastDueModal
    ? _c("div", { staticClass: "h-vertical-align-container" }, [
        _c("div", { staticClass: "modal__overlay" }),
        _c(
          "div",
          { staticClass: "modal__wrapper modal__wrapper--marketingConsent" },
          [
            _c("div", { staticClass: "modal__marketingconsent" }, [
              _c("h1", [_vm._v("Account Past Due")]),
              _vm._m(0),
              _c("a", { attrs: { href: _vm.merchantURL } }, [
                _c("button", { staticClass: "btn btn--purpleLight" }, [
                  _vm._v("Update")
                ])
              ]),
              _c(
                "button",
                {
                  staticClass: "btn btn--white",
                  on: {
                    click: function($event) {
                      _vm.closeModal()
                    }
                  }
                },
                [_vm._v("Later")]
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marketingConsent--container" }, [
      _c("p", [
        _vm._v(
          "Your billing information needs to be updated to reenable your plan."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86a3b70e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86a3b70e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotifyPastDue.vue
// module id = null
// module chunks = 